import React from 'react';
import SadIcon from './SadIcon';
import { useTranslations } from '../hooks/useTranslations';
export function NoResultSection() {
    const { t } = useTranslations();
    return (React.createElement("div", { className: "WhSearch-NoResultSection" },
        React.createElement("div", { className: "WhSearch-NoResultSection__icon" },
            React.createElement(SadIcon, null)),
        React.createElement("div", { className: "WhSearch-NoResultSection__header" }, t('noResultsFoundTitle')),
        React.createElement("div", { className: "WhSearch-NoResultSection__description" }, t('noResultsFoundDescription'))));
}
//# sourceMappingURL=NoResultSection.js.map